---
de:
  marketplace:
    add_now: Jetzt hinzufügen
    add_tags: Schlagwörter hinzufügen
    body: Haupttext
    card_info: Kartendetails
    confirmation: Bist du sicher?
    contact_info: Kontaktinformationen
    filter: Nach Kategorie filtern
    heading: Marktplatz
    image: Bild
    image_to_large: Die Bildgröße sollte weniger als 5 MB betragen!
    tags: Schlagwörter
    unexpected_error: Ein unerwarteter Fehler ist aufgetreten.
